import CustomInput from "../CustomInput";

const ONE_UKRAINIAN_WORD = /^([А-ЕЖ-ЩЬЮЯЇІЄҐ]+['-]?)*$/;
const MAX_SIZE = 30;

class NameInput extends CustomInput {
  transform = value =>
    this.clearSpaces(value)
      .substring(0, MAX_SIZE)
      .toUpperCase();

  validate = value => ONE_UKRAINIAN_WORD.test(value);
}

export default NameInput;
